import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import CSSModules from 'react-css-modules';
import { ACTIONS } from '../../constants/strings';
import beautifyName from './beautifyName';
import styles from './index.styl';

@CSSModules(styles, { allowMultiple: true })
export default class Program extends PureComponent {
  static propTypes = {
    program: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      organization: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
      }),
      description: PropTypes.string,
      logo: PropTypes.objectOf(PropTypes.string),
      surveys: PropTypes.array,
    }).isRequired,
    className: PropTypes.string,
  };

  static defaultProps = {
    className: '',
  };

  render() {
    const { program, className } = this.props;
    const { name, description, organization } = program;

    return (
      <div {...{ className }}>
        <div styleName="heading">
          <div>
            <p styleName="title">{beautifyName(name)}</p>
          </div>
        </div>
        <If condition={organization}>
          <p styleName="subtitle">{organization.name}</p>
        </If>
        <If condition={description}>
          <div styleName="block">
            <p styleName="blockTitle">
              <FormattedMessage {...ACTIONS.program.subtitle} />
            </p>
            <p styleName="blockContent">{description}</p>
          </div>
        </If>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Program/index.jsx